module.exports = __webpack_public_path__ + "static/logo.7f3a05cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 675
// module chunks = 114276838955818